function isTableScroll() {
	$('.js-table-inner').each(function() {

    	var containerWidth  = $(this).outerWidth(),
    		tableWidth 		= $(this).children('table').outerWidth(); 

    	if (tableWidth > containerWidth) {
    		$(this).parent().addClass('js-table--scroll');
    		console.log(1);
    	} else {
    		$(this).parent().removeClass('js-table--scroll');
    		console.log(2);
    	}	
    });
};

function checkTableScrollButtons() {
	$('.js-table-inner').each(function() {

    	var width = $(this).outerWidth(),
        	scrollWidth = $(this)[0].scrollWidth,
        	scrollLeft = $(this).scrollLeft();

        if (scrollWidth - width === scrollLeft){
            $(this).siblings('.js-table-scroll-right').addClass('js-inactive');
        } else {
        	$(this).siblings('.js-table-scroll-right').removeClass('js-inactive');
        }

        if (scrollLeft===0){
            $(this).siblings('.js-table-scroll-left').addClass('js-inactive');
        } else {
        	$(this).siblings('.js-table-scroll-left').removeClass('js-inactive');
        }

    });
}

$(document).ready(function(){
	var timeout_id;
	
	$( ".s-content table, .s-wysiwyg table" ).wrap( "<div class='m-table'><div class='m-table__inner js-table-inner'></div>" );
	// $(".js-table-inner").before('<button class="m-table__scroll m-table__scroll-left js-table-scroll-left"><i class="fa fa-angle-left" aria-hidden="true"></i></button>');
	// $(".js-table-inner").after('<button class="m-table__scroll m-table__scroll-right js-table-scroll-right"><i class="fa fa-angle-right" aria-hidden="true"></i></button>');

	// isTableScroll();
	// checkTableScrollButtons();

	// $('.js-table-inner').scroll( function() {
	// 	console.log('scrolling');
	// 	checkTableScrollButtons()
	// });

	// $(window).on("resize orientationchange",function(){
	//  	clearTimeout(timeout_id);
    //     timeout_id = setTimeout(function(){
    //     	isTableScroll();
    //     	checkTableScrollButtons();
    //     }, 100);
    // });


    // Scroll buttons click events
    // $('body').on('click', '.js-table-scroll-right', function () {   
    // 	var pos = $(this).siblings('.js-table-inner').scrollLeft() + 200;
    // 	$(this).siblings('.js-table-inner').animate( { scrollLeft: pos }, 300 );
    // });

    // $('body').on('click', '.js-table-scroll-left', function () {
    // 	var pos = $(this).siblings('.js-table-inner').scrollLeft() - 200;
    // 	$(this).siblings('.js-table-inner').animate( { scrollLeft: pos }, 300 );
    // });

});
